module.exports = __webpack_public_path__ + "img/fumazhuiyuan2.9915fb32.png";